/**
 * Shared MIME predicates, in two deliberately distinct tiers:
 * - `isImageMime` — "is this an image at all" (prefix check).
 * - `isInlineImageMime` — "can the browser decode it" (whitelist). Use this
 *   wherever the type gates an `<img>`/lightbox: HEIC is an image by prefix but
 *   browsers cannot decode it, and exclusions only work with a whitelist.
 */

/** Whether a MIME type is an image (inline-previewable). Nullish → false. */
export const isImageMime = (mime: string | null | undefined): boolean =>
	!!mime?.startsWith('image/')

/** Browser-renderable image types. HEIC is deliberately absent. */
export const INLINE_IMAGE_MIME_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp']

/** Whether a MIME type is browser-renderable as an inline image. Nullish → false. */
export const isInlineImageMime = (mime: string | null | undefined): boolean =>
	!!mime && INLINE_IMAGE_MIME_TYPES.includes(mime)

/** Whether a MIME type is a PDF (gets the red PDF badge treatment). Nullish → false. */
export const isPdfMime = (mime: string | null | undefined): boolean =>
	mime === 'application/pdf'
